module.exports = {render: function () {with(this){return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M6 2.9v19h13v-19H6zm12 1v8H7v-8h11zm-11 17v-8h11v8H7zM27.5 22l-3.3-5.5h6.7z"}})])}}};


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg-icons/components_window.svg
// module id = 701
// module chunks = 2